export default __webpack_public_path__ + "static/media/img_japanese_large.a82ba6c1.png";